import * as React from "react";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";

import { draftCompanySelector, editModeSelector, companyDescriptionsSelector } from "../selectors";
import { RootState } from "../../state";
import { loadCompanyAboutWorker } from "../actions";
import AboutDescriptionSection from "./AboutDescriptionSection";

interface OwnProps {
  params: { companyId: string };
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class AboutPageContainer extends React.Component<Props> {
  public static async fetchInitialData(getState: () => RootState, dispatch: Dispatch<RootState>) {
    const company = draftCompanySelector(getState());
    await dispatch(loadCompanyAboutWorker(company.id));
  }

  public render() {
    const { company, descriptions, editable } = this.props;
    return (
      <>
        {descriptions.map(description => (
          <AboutDescriptionSection
            key={description.type}
            description={description}
            company={company}
            editable={editable}
          />
        ))}
      </>
    );
  }
}

function mapStateToProps(state: RootState) {
  return {
    company: draftCompanySelector(state),
    descriptions: companyDescriptionsSelector(state),
    editable: editModeSelector(state),
  };
}

function mapDispatchToProps(dispatch: Dispatch<RootState>) {
  return bindActionCreators(
    {
      loadCompanyAboutWorker,
    },
    dispatch
  );
}

const connected = connect(mapStateToProps, mapDispatchToProps)(AboutPageContainer);
export default hot(module)(connected);



// WEBPACK FOOTER //
// ./frontend/src/companies/components/AboutPageContainer.tsx